import { PendingApprovalEntriesResultsGroup } from '@sit/client-shared';

type DoneTimesheetGroups = Record<string, PendingApprovalEntriesResultsGroup>;

export const mergeDoneApprovalsPage = (
  groups: PendingApprovalEntriesResultsGroup[],
  currentState: DoneTimesheetGroups = {},
  mapTitle = (t: string) => t,
) =>
  groups.reduce((state, newGroup) => {
    const title = mapTitle(newGroup.title);
    const currentGroup = state[title] ?? { title: title, results: [] };
    const newResults =
      currentGroup.results.length > 0
        ? newGroup.results.filter((result) => !currentGroup.results.find((r) => r.id === result.id))
        : newGroup.results;
    const additionalHours = newResults.reduce((totalHours, current) => totalHours + current.totalHours, 0);
    const results = [...currentGroup.results, ...newResults];
    const totalHours = (currentGroup.totalHours ?? 0) + additionalHours;

    return {
      ...state,
      [title]: {
        title,
        results,
        totalHours,
      },
    };
  }, currentState);
